// Brand session management for One Hope Wine vs One Hope Winery
(function() {
    'use strict';

    // Store BRAND_SESSION_KEY in window for global access
    window.BRAND_SESSION_KEY = 'onehope_brand';

    // Configuration
    const CONFIG = {
        BRAND_SESSION_KEY: window.BRAND_SESSION_KEY,
        BRANDS: {
            WINE: 'One Hope Wine',
            WINERY: 'One Hope Winery'
        },
        DEFAULT_BRAND: 'One Hope Wine',
        SELECTORS: {
            BRAND_SWITCHER: '[data-brand-switcher]',
            PAGE_BRAND_META: 'meta[name="page-brand"]'
        },
        STYLES: {
            BRAND_SWITCHER_ACTIVE: 'btn-sand',
            BRAND_SWITCHER_INACTIVE: 'btn-neutral'
        }
    };

    let brandSwitchers = null;

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }

    document.addEventListener('DOMContentLoaded', function() {
        setupEventListeners();
        hideGFPToolbarForWinery();
    });

    function init() {
        initializeBrandSession();
    }

    function initializeBrandSession() {
        const bodyElement = document.querySelector('body[data-page-brand]');
        const pageBrand = bodyElement?.getAttribute('data-page-brand');
        const validPageBrand = isValidBrand(pageBrand) ? pageBrand : CONFIG.DEFAULT_BRAND;
        const existingSession = sessionStorage.getItem(window.BRAND_SESSION_KEY);

        if (pageBrand && isValidBrand(pageBrand) && pageBrand !== existingSession) {
            sessionStorage.setItem(window.BRAND_SESSION_KEY, pageBrand);
            updateCartAttributes(pageBrand);
            updateBrandSwitcherStyles(pageBrand);
            return;
        }

        if (existingSession && isValidBrand(existingSession)) {
            updateCartAttributes(existingSession);
            return;
        }

        sessionStorage.setItem(window.BRAND_SESSION_KEY, validPageBrand);
        updateCartAttributes(validPageBrand);
    }

    function setupEventListeners() {
        brandSwitchers = document.querySelectorAll(CONFIG.SELECTORS.BRAND_SWITCHER);

        brandSwitchers.forEach(switcher => {
            switcher.addEventListener('click', handleBrandSwitcherClick);
        });
    }

    async function handleBrandSwitcherClick(event) {
        const selectedBrand = this.getAttribute('data-brand');

        if (!isValidBrand(selectedBrand)) {
            console.warn('Invalid brand selected:', selectedBrand);
            return;
        }

        sessionStorage.setItem(window.BRAND_SESSION_KEY, selectedBrand);

        // Let modified clicks (new tab/window) open normally without waiting on cart update.
        if (event.metaKey || event.ctrlKey || event.shiftKey || event.button === 1) {
            return;
        }

        const href = this.getAttribute('href');
        if (!href || href === '#') return;

        // Update the cart brand attribute synchronously before navigating so that any
        // follow-on navigation from the destination (e.g. winery landing -> /collections/*)
        // sees the correct cart.attributes.brand on first paint. brand-detection.liquid
        // falls back to the cart for collection/product pages (which have no page metafield),
        // so without this await the cart can still be "One Hope Wine" when the user clicks
        // into a winery collection, causing it to render with the wrong brand background.
        event.preventDefault();

        // Show a loading affordance during the cart sync so the click feels responsive on
        // slow networks. Clicked button pulses; sibling button dims and is unclickable.
        // No cleanup needed on success — the page unloads on navigation.
        const switcherGroup = this.closest('.brand-selector-header');
        if (switcherGroup) switcherGroup.classList.add('is-loading');
        this.classList.add('is-loading');

        await updateCartAttributes(selectedBrand);
        window.location.href = href;
    }

    function updateBrandSwitcherStyles(currentBrand) {
        brandSwitchers = document.querySelectorAll(CONFIG.SELECTORS.BRAND_SWITCHER);

        if (!currentBrand || !brandSwitchers) return;

        brandSwitchers.forEach(switcher => {
            const switcherBrand = switcher.getAttribute('data-brand');
            const isCurrent = switcherBrand === currentBrand;

            switcher.classList.toggle(CONFIG.STYLES.BRAND_SWITCHER_ACTIVE, isCurrent);
            switcher.classList.toggle(CONFIG.STYLES.BRAND_SWITCHER_INACTIVE, !isCurrent);
        });
    }

    function isValidBrand(brand) {
        return brand && Object.values(CONFIG.BRANDS).includes(brand);
    }

    async function updateCartAttributes(brandName) {
        try {
            const cartData = {
                attributes: {
                    brand: brandName,
                    site: null
                }
            };

            const response = await fetch('/cart/update.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(cartData)
            });

            if (response.ok) {
                const updatedCart = await response.json();

                document.dispatchEvent(new CustomEvent('theme:cart:change', {
                    detail: { cart: updatedCart },
                    bubbles: true
                }));

                return true;
            } else {
                console.error('Failed to update cart attributes:', response.statusText);
                return false;
            }
        } catch (error) {
            console.error('Error updating cart attributes:', error);
            return false;
        }
    }

    function hideGFPToolbarForWinery() {
        const isWineryPage = document.body.classList.contains('winery-background') ||
                           document.querySelector('.winery-background') ||
                           document.querySelector('main.winery-background');

        if (!isWineryPage) return;

        const hideToolbar = () => {
            const toolbar = document.getElementById('gfp_shopper_toolbar');

            if (toolbar) {
                toolbar.style.display = 'none';
                toolbar.style.visibility = 'hidden';
            }
        };

        hideToolbar();

        const observer = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
                if (mutation.type === 'childList') {
                    mutation.addedNodes.forEach((node) => {
                        if (node.nodeType === 1) {
                            if (node.id === 'gfp_shopper_toolbar') {
                                hideToolbar();
                            }

                            const toolbar = node.querySelector?.('#gfp_shopper_toolbar');
                            if (toolbar) {
                                hideToolbar();
                            }
                        }
                    });
                }
            });
        });

        observer.observe(document.body, {
            childList: true,
            subtree: true
        });

        const intervalCheck = setInterval(() => {
            const toolbar = document.getElementById('gfp_shopper_toolbar');
            if (toolbar) {
                hideToolbar();
                clearInterval(intervalCheck);
            }
        }, 500);

        setTimeout(() => {
            clearInterval(intervalCheck);
        }, 10000);
    }
})();
